import { connect } from "react-redux";
import React from "react";
import { bindActionCreators } from "redux";
import moment from "moment";
import HeaderComponent from "../header/header";
import LoadingOverlay from "react-loading-overlay";
import ODModalHeader from "../header/ODsubHeader";
import { RouteComponentProps, Link } from "react-router-dom";
import { IProject, IAuthenticationState, IApplicationState } from "../../../../models/applicationState";
import IProjectActions, * as projectActions from "../../../../redux/actions/projectActions";
import AnalysisService from "../../../../services/analysisService";

const divStyle = {}
export interface IAnalysisProps extends RouteComponentProps, React.Props<AnalysisOD> {
    project: IProject;
    path: object;
    loggedInUser: IAuthenticationState;
    actions: IProjectActions;
    ptype: string;
    Precision:string;
    Reecall:string;
    AvgPrecision:string;
}

function mapStateToProps(state: IApplicationState) {
    return {
        project: state.currentProject,
        loggedInUser: state.loggedInUser,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(projectActions, dispatch),
    };
}

export interface IAnalysisState {
    analysisData: any;
    loadAnalysisData: boolean;
    ptype:string;
    Precision:string;
    Reecall:string;
    AvgPrecision:string;
    od_accuracy:any;
    fmetrics:any;
}

@connect(mapStateToProps, mapDispatchToProps)

export default class AnalysisOD

    extends React.Component<IAnalysisProps, IAnalysisState> {
    public state: IAnalysisState = {
        analysisData: {},
        loadAnalysisData: false,
        ptype:"",
        Precision:"1",
        Reecall:"1",
        AvgPrecision:"1",
        od_accuracy:[],
        fmetrics:[],
    };

    public async componentDidMount() {

        this.getAnalysisResults();
                 
          
               
                                                 
                                              
    }


public getAnalysisResults = async () => {
   
    //debugger;
    const projectName = this.props.match.params["projectName"];
    const projecttype = this.props.match.params["type"];
    if (projectName) {
        this.setState({ loadAnalysisData: true,ptype:projecttype  });

        let data;
        if(projecttype === 'ocr')
        { 
            console.log("ocr analysis");

              data = await this.props.actions.getAnalyseResult(projectName, "yes");
        }
        else
        {
           // debugger;
            const signInUserSession = localStorage.getItem("signInUserSession");
            const user = signInUserSession && JSON.parse(signInUserSession);
            const userId = user && user.user.oid;
            //const projname=  projectName+'-'+userId;
            const projname=  projectName;


            console.log("od analysis");
            const analysisService = new AnalysisService();
           //  data = await analysisService.getCustomVisionAnalyseResultData(this.props.project.cvProjId,projname,userId,"Regular","yes");
           data = await analysisService.getCustomVisionAnalyseResultData(projname,userId);
       } 
       console.log(data);

       if (data) {
             const dataObj = Object.assign({}, data);
             //const today = moment().format("YYYY/MM/DD");
             const today = moment().format("DD-MMM-YYYY");
             dataObj["currentDate"] = today;
             const fields_metrics=[];
             const od_accuracy=[];
             if (data.status==="completed") {

             const ametrics = dataObj.accuracy?dataObj.accuracy.split('$$$')[0]:{};
             
            const albl1 = ametrics?ametrics.split("{"):[];
            // [{​'Precision': '', 'Recall': '', 'Average_Precision': ''}​]
            albl1.forEach((lblval) =>{
                debugger;
               const lblval1 = lblval.replace("Average_Precision","AP");
                                            if (lblval1.includes("Precision")) {
                                               
                                               const lbl3 =lblval1.split('Precision');
                                             const lbl4 =lbl3[1].split(',');
                                              const lbl5 =lbl4[0].split(':');
                                              const lbl5a =lbl4[1].split(':');
                                              const lbl5b =lbl4[2].split(':');

                                              const lbl6 = lbl5[1].trim().replace("'","");
                                              const lbl6a = lbl5a[1].trim().replace("'","");
                                              const lbl6b = lbl5b[1].trim().replace("'","");
           
                                             const precision = lbl6.substr(0,lbl6.length-1);
                                            
                                             
                                             const recall = lbl6a.substr(0,lbl6a.length-1);
                                             const lbl7b = lbl6b.substr(0,lbl6b.length-1);
           
                                            // const Recall = lbl7a[0];
                                             const avg_Precision = lbl6b.split('}')[0].trim().replace("'",""); 
                                             
                                             od_accuracy.push(
                                               {'Precision':precision,'Recall':recall,'Average_Precision':avg_Precision }
                                             );

        }      
});

// tags

const fmetrics = dataObj.fields?dataObj.fields.split('$$$')[0]:{};
 
const lbl1 = fmetrics?fmetrics.split("{"):[];

lbl1.forEach((lblval) =>{
                               if (lblval.includes("fieldName")) {
                                  
                                  const lbl3 =lblval.split('fieldName');
                                const lbl4 =lbl3[1].split(',');
                                 const lbl5 =lbl4[0].split(':');
                                 const lbl5a =lbl4[1].split(':');

                                 const lbl6 = lbl5[1].trim().replace("'","");
                                  const lbl6a = lbl5a[1].trim().replace("'","");
                                 const flName = lbl6.substr(0,lbl6.length-1);
                                //   AllLabels.push(flName);
                                 
                                 const lbl7a = lbl6a.substr(0,lbl6a.length-1);
                                 const accur = lbl7a.split('}')[0];
                                 
                                   //AllLabels1.push(accur);
                                 
                                 
                                 fields_metrics.push(
                                   {'fieldName':flName,'accuracy':accur }
                                 );
                                 
                               }  
                               });


//
                            }
this.setState({ analysisData: dataObj,od_accuracy:od_accuracy,fmetrics:fields_metrics, loadAnalysisData: false });
} else {
this.setState({ analysisData: {}, loadAnalysisData: false });
}
}

}
        


    public render() {
     //   const projecttype = this.props.match.params["type"];
     //debugger;
        const { analysisData,fmetrics,od_accuracy } = this.state;
        const { match } = this.props;
      //  const projecttype = this.props.match.params["type"];
      const projecttype = "od";
       // const {ptype} = this.ptype;
        return (
            <div style={divStyle} >
                <LoadingOverlay
                    active={this.state.loadAnalysisData}
                    spinner
                    className=""
                    text="loading Analysis Data"
                >
                    <HeaderComponent
                        history={this.props.history}
                        match={this.props.match}
                        location={this.props.location} />
                    <ODModalHeader
                        history={this.props.history}
                        match={this.props.match}
                        actions={this.props.actions}
                        location={this.props.location}
                        project={this.props.project} />

                    <div className="container-fluid">
                        <div className="row mt-4">
                            <div className="offset-2 col-md-8 gutters-5-ipad">
                                <div className="card shadow">
                                    <div className="row">
                                        <div className="col-md-10">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label> Project Name :</label> {analysisData && analysisData.project_name}
                                                </div>

                                                <div className="col-md-6 text-right">
                                                    {/*<label> Accuracy :</label> {analysisData.accuracy ? `${(analysisData.accuracy * 100).toFixed(2)} %` : "Not Trained"}*/}
                                                </div>
                                                <div className="col-md-6">
                                                    <label> Model ID :</label> {analysisData && analysisData.model_id}
                                                </div>
                                                <div className="col-md-6 text-right">
                                                    <label> Date :</label> {analysisData && analysisData.currentDate}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card shadow mt-2">

                                    {projecttype==='od'?
                                         <>
                                         {  analysisData.status==="completed"?

                                         <div>
                                            <div className="wrap-body-test-tbl">
                                                  <table className="table table-dark table-striped">
                                                    <thead>
                                                        <tr>
                                                          {  /*<th>Tag</th>*/}
                                                            <th> Precision </th>
                                                            <th> Recall </th>
                                                            <th> Average Precision </th>
                                                           { /*<th> Image count  </th>*/}
                                                        </tr>
                                                    </thead>
                                                    {od_accuracy.map((fields, index) => {
                                                            const accuracyP = (fields.Precision * 100).toFixed(2);
                                                            const accuracyR = (fields.Recall * 100).toFixed(2);
                                                            const accuracyAP = (fields.Average_Precision * 100).toFixed(2);
                                                           // const accuracy = (fields.accuracy * 100).toFixed(2);
                                                            return (
                                                                <tr key={index}>
                                                                    {/*<td>{fields.fieldName}</td>*/}
                                                                    <td>{accuracyP} %</td>
                                                                    <td>{accuracyR} %</td>
                                                                    <td>{accuracyAP} %</td>
                                                                   {/*   <td>{fields.images}</td>*/}
                                                                </tr>
                                                            );
                                                        })}
 
                                                    </table>
                                             </div> 
                                             
                                    <div className="wrap-body-test-tbl">
                                        {analysisData &&  fmetrics ?
                                            <>

                                                <table className="table table-dark table-striped">
                                                    <thead>
                                                        <tr>
                                                            <th>Name</th>
                                                            <th> Accuracy </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {fmetrics.map((fields, index) => {
                                                            const accuracy = (fields.accuracy * 100).toFixed(2);
                                                            return (
                                                                <tr key={index}>
                                                                    <td>{fields.fieldName}</td>
                                                                    <td>{accuracy} %</td>
                                                                </tr>
                                                            );
                                                        })}
                                                    </tbody>
                                                </table>
                                            </>
                                            : <span className="text-center mt-5">No Fields</span>}
                                    </div>

                                             </div>
                                             
                                             :
                                             <div>
 <div className="wrap-body-test">

     
     <div className="row">
     <div className="col-md-10">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label> Training Status :</label> {analysisData.status}
                                                </div>
                                                
                                                {  analysisData.status==="initializing"?
                                                 <div className="col-md-6">
                                                  <button onClick={() => this.getAnalysisResults()}
                        type="button" className="train">
                            <i className="fa fa-cogs" aria-hidden="true"> </i> Refresh
                    </button>
                                   
                                             </div>
                                                    :
                                                    <div className="col-md-6">
                                                      <Link            
                                            to={`/projects/${match.params["projectName"]}/${match.params["projectId"]}/odedit`}
                                            className="btn btn-md"><i className="fa fa-check-circle" aria-hidden="true"> </i> Back</Link>
                                   
                                   
                                                </div>
                                                  }
                                                
                                              
                                                </div>
                                                </div>
                                                </div>
     
 </div>
                                             </div>
    }
</>
                               :
                                    <div className="wrap-body-test">
                                        {analysisData && analysisData.fields_metrics ?
                                            <>

                                                <table className="table table-dark table-striped">
                                                    <thead>
                                                        <tr>
                                                            <th>Name</th>
                                                            <th> Accuracy </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {analysisData.fields_metrics.map((fields, index) => {
                                                            const accuracy = (fields.accuracy * 100).toFixed(2);
                                                            return (
                                                                <tr key={index}>
                                                                    <td>{fields.fieldName}</td>
                                                                    <td>{accuracy} %</td>
                                                                </tr>
                                                            );
                                                        })}
                                                    </tbody>
                                                </table>
                                            </>
                                            : <span className="text-center mt-5">No Fields</span>}
                                    </div>
    }

                                    <div className="text-center mt-2">
                                        <Link
                                            to={`/ODProjects/${match.params["projectName"]}/${match.params["projectId"]}/od/test-files/na`}
                                            className="btn btn-md"><i className="fa fa-check-circle" aria-hidden="true"> </i> Test</Link>
                                   
                                   
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </LoadingOverlay>
            </div>
        );
    }
}
